import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MotLoud - Motorsport Telemetry & Management';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // Initialize authentication state from stored token
    this.authService.initializeAuth();
  }
}
